import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import VForm17VodalysBridge from './components/VForm17VodalysBridge.vue'
import VodalysBridgeInstructions from './components/VodalysBridgeInstruction.vue'
declareVconsoleComponent('vForm17VodalysBridge', VForm17VodalysBridge, 'VForm17VodalysBridge')
declareVconsoleComponent('vodalysBridgeInstructions', VodalysBridgeInstructions, 'VodalysBridgeInstructions')